import { render } from "./PrimaryFeature.vue?vue&type=template&id=7b10445b&scoped=true"
import script from "./PrimaryFeature.vue?vue&type=script&lang=js"
export * from "./PrimaryFeature.vue?vue&type=script&lang=js"

import "./PrimaryFeature.vue?vue&type=style&index=0&id=7b10445b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b10445b"]])

export default __exports__